import { pingback, Pingback, PingbackActionType } from '@giphy/js-analytics'
import { PingbackEventType } from '@giphy/js-types'
import { ReactNode, useContext, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { ILoggedInUser } from 'types'
import UserContext from '../../../context/user-context'

const fire = ({
    actionType,
    responseId,
    arp,
    eventType,
    user,
}: {
    actionType: PingbackActionType
    responseId: string
    arp: string
    eventType: 'DROPDOWN_AUTOCOMPLETE' | 'DROPDOWN_CHANNEL_SUGGEST' | 'DROPDOWN_TRENDING_SUGGEST'
    user: ILoggedInUser | undefined | null
}) => {
    if (!responseId) {
        console.error(`No response id for dropdown ${name}`)
        return null
    }

    const action: Pingback = {
        userId: user?.id?.toString(),
        actionType,
        attributes: { search_response_id: responseId },
        eventType: eventType as PingbackEventType,
        analyticsResponsePayload: arp,
    }
    pingback(action)
}

const DropdownPingback = ({
    responseId,
    children,
    onClick,
    eventType,
    arp,
}: {
    children: ReactNode
    responseId: string
    arp: string
    eventType: 'DROPDOWN_AUTOCOMPLETE' | 'DROPDOWN_CHANNEL_SUGGEST' | 'DROPDOWN_TRENDING_SUGGEST'
    onClick: () => void
}) => {
    const { user } = useContext(UserContext)
    const [ref, inView] = useInView({ triggerOnce: true })
    useEffect(() => {
        if (inView) {
            fire({
                actionType: 'SEEN',
                arp,
                user,
                eventType,
                responseId,
            })
        }
    }, [inView, responseId, user, arp, eventType])
    return (
        <div
            ref={ref}
            onClick={() => {
                fire({
                    actionType: 'CLICK',
                    arp,
                    user,
                    eventType,
                    responseId,
                })
                onClick?.()
            }}
        >
            {children}
        </div>
    )
}

export default DropdownPingback
